<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <span>{{ $t('current_lang') }}</span>
      </CHeaderNavLink>
    </template>
    <CDropdownItem @click="switchLang('zh_tw')">
      {{ $t('chinese_tw') }}
    </CDropdownItem>
    <CDropdownItem @click="switchLang('en')">
      {{ $t('english') }}
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'TheHeaderDropdownLang',
  props: {
    initMenu: {
      type: Function
    }
  },
  methods: {
    ...mapActions([
      'setLang'
    ]),
    switchLang: function (lang) {
      this.setLang(lang)
      this.$i18n.locale = lang
      this.initMenu()
    }
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>